export const GRANT_MANAGEMENT_PATH = "/grants/management";

function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export function grantManagementHref(tab?: string): string {
  const key = tab?.trim() || "funds";
  return `${GRANT_MANAGEMENT_PATH}?tab=${encodeURIComponent(key)}`;
}

export function grantManagementFundHref(fundId: number | string): string {
  return `${GRANT_MANAGEMENT_PATH}/funds/${fundId}`;
}

export function isGrantManagementPath(pathname: string): boolean {
  const path = normalizePathname(pathname);
  return path === GRANT_MANAGEMENT_PATH || path.startsWith(`${GRANT_MANAGEMENT_PATH}/`);
}

/** Grant pipeline list and detail routes (/grants, /grants/:id, /grants/funders/:id). Excludes grant management. */
export function isGrantPipelinePath(pathname: string): boolean {
  const path = normalizePathname(pathname);
  if (path === "/grants") return true;
  if (isGrantManagementPath(path)) return false;
  return path.startsWith("/grants/");
}

/** Active state for nested sidebar links (Grant pipeline vs Grant management). */
export function isGrantNavLinkActive(linkTo: string, pathname: string): boolean {
  const pathOnly = linkTo.split("?")[0] ?? linkTo;
  if (pathOnly === "/grants") {
    return isGrantPipelinePath(pathname);
  }
  if (pathOnly.startsWith("/grants/management")) {
    return isGrantManagementPath(pathname);
  }
  return false;
}
